webpackJsonp([6],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_popup_festival__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_popup_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_authCommon__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_authCommon__["a" /* default */]],
    components: {
        popupFestival: __WEBPACK_IMPORTED_MODULE_0__components_popup_festival__["a" /* default */],
        popup: __WEBPACK_IMPORTED_MODULE_1__components_popup_vue__["a" /* default */]
    },
    data: function data() {
        return {
            langSelect: lang_select,
            cookielang: _cookie,
            lang: lang,
            formData: {
                accname: '',
                pass: ''
            },
            error: {
                loginIdReq: false,
                message: ''
            },
            customTemplate: window._customTemplate,
            popupFlag: false,
            emptytoken: window.emptytoken,
            showCreditDemoFlag: window.showCreditDemoFlag,
            token: window.token,
            showDemo: window.showDemo,
            showLogo: window.showLogo,
            isApi: window.isApi
        };
    },

    methods: {
        altDisplay: function altDisplay() {
            if (!this.formData.accname) {
                return 'visibility : visible';
            }
            var style = this.formData.accname.length <= 0 ? 'visible' : 'hidden';
            return 'visibility : ' + style;
        },
        customIcon: function customIcon() {
            if (this.customTemplate && !this.customTemplate['login_logo']) {
                return 'index_top_pic';
            }
        },
        login: function login() {
            var _this = this;

            if (this.formData.accname == '') {
                this.error.loginIdReq = true;
                this.error.message = this.lang.emptyLoginId;
            } else if (this.formData.pass == '') {
                this.error.loginIdReq = true;
                this.error.message = this.lang.emptyPassword;
            } else {
                this.error.loginIdReq = false;
                this.formData.token = token.arr_9 + '|' + this.formData.accname;
                this.$ajax({
                    method: 'post',
                    url: '',
                    data: this.formData
                }).done(function (response) {
                    if ($('#remember:checked').length > 0) {
                        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('_userName', _this.formData.accname);
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('_userName', null);
                    }
                }).catch(function (error) {
                    _this.error.loginIdReq = true;
                    _this.error.message = error.responseJSON.message;
                });
            }
        },

        changeLanguage: function changeLanguage(value) {
            this.$ajax({
                url: '',
                type: 'get',
                data: {
                    language: value,
                    token: token.arr_3
                }
            }).then(function (response) {
                window.location.reload();
            });
        },
        lang_allowed: function lang_allowed(langid) {
            if (langid == 1 || langid == 2 || langid == 3) {
                return true;
            }
            return false;
        },
        langClass: function langClass(lang) {
            if (lang == this.cookielang) {
                return 'lang2';
            }
            return 'lang';
        },
        demo: function demo() {
            this.popupFlag = true;
        },
        demoLogin: function demoLogin() {
            this.$ajax({
                method: 'post',
                url: window.demoLogin,
                data: {
                    token: token.arr_9
                }
            }).done(function (res) {
                return false;
            }.bind(this)).catch(function (errRes) {
                console.log(errRes);
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        $('#loading-root-ele').hide();
        if (__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('_userName') != 'null') {
            this.formData.accname = __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('_userName');
            $('#remember').prop('checked', true);
        } else {
            $('#remember').prop('checked', false);
        }
        $('#username').focus();

        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('setDemoFlag', function (res) {
            _this2.popupFlag = res;
        });
    }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_authCommon__ = __webpack_require__(130);



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_authCommon__["a" /* default */]],
    mounted: function mounted() {
        if (this.popupFestival) {
            this.popupBreath();
        }
    }
});

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      popupFestival: window._popupFestival,
      inputLength: window._inputLength
    };
  },

  methods: {
    popupBreath: function popupBreath() {
      var VUE = this;
      if (this.popupFestival.festival_popup.flag == true) {
        $('.fadein').fadeIn();
        setTimeout(function () {
          VUE.closePopup();
        }, 5000);
      }
    },
    closePopup: function closePopup() {
      $('.fadein').fadeOut();
    }
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_popup__ = __webpack_require__(264);



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_popup__["a" /* default */]],
    props: {
        democreditLogin: Boolean,
        lang: null,
        emptytoken: null,
        invalidtoken: null
    },
    data: function data() {
        return {
            token_demo: this.token_demo,
            error: {
                tokenReq: false,
                tokenmessage: ''
            }
        };
    },
    mounted: function mounted() {
        this.popupBreath();
    }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_apps_auth_login_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);




new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#login',
  template: '<Login ></Login>',
  components: { Login: __WEBPACK_IMPORTED_MODULE_0__vue_apps_auth_login_vue__["a" /* default */] }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a067e2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(266);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a067e2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_festival_vue__ = __webpack_require__(129);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40bc068f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_festival_vue__ = __webpack_require__(262);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_festival_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40bc068f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_festival_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popupFestival)?_c('div',[_c('div',{staticClass:"fadein"},[_c('div',{staticClass:"popup-image"},[_c('div',{staticClass:"guide-close-button floating-right"},[_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":_vm.closePopup}})]),_vm._v(" "),_c('div',{staticClass:"message"}),_vm._v(" "),_c('img',{staticStyle:{"cursor":"pointer","height":"100%"},attrs:{"src":_vm.popupFestival.festival_popup.img,"id":"fadein1-img"}})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68ffcb00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_vue__ = __webpack_require__(265);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68ffcb00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_events_event_bus__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    popupBreath: function popupBreath() {
      var VUE = this;
      if (this.democreditLogin == true) {
        $('.fadeinDemo').fadeIn();
      }
    },
    closePopup: function closePopup() {
      __WEBPACK_IMPORTED_MODULE_0__vue_events_event_bus__["a" /* default */].$emit('setDemoFlag', false);
      $('.fadeinDemo').fadeOut();
    },
    login: function login() {
      var _this = this;

      if (this.token_demo == '' || typeof this.token_demo == 'undefined') {
        this.error.tokenReq = true;
        this.error.tokenmessage = this.lang.emptytoken;
      } else {
        var re = /^[a-z\d\-_\s]+$/i;
        var re1 = re.test(this.token_demo);

        if (re1) {
          var url = _baseUrl + '/login';
          this.$ajax({
            method: 'post',
            url: url,
            data: {
              token: this.token_demo,
              action: 'logincreditdemo'
            }
          }).done(function (response) {
            console.log("done");
          }).catch(function (error) {
            _this.error.tokenReq = true;
            _this.error.tokenmessage = error.responseJSON.message;
          });
        } else {
          this.error.tokenReq = true;
          this.error.tokenmessage = this.lang.invalidtoken;
        }
      }
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"democreditloginPopup"},[_c('div',{staticClass:"fadeinDemo"},[_c('div',{staticClass:"popup-box"},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"demo_caption"},[_c('span',[_vm._v(_vm._s(_vm.lang.entertoken))])]),_vm._v(" "),_c('div',{staticClass:"demo_token"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token_demo),expression:"token_demo"}],attrs:{"type":"text","id":"tokendemo","maxlength":"8"},domProps:{"value":(_vm.token_demo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token_demo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"div_error",attrs:{"id":"div_error","name":"div_error"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.tokenReq),expression:"error.tokenReq"}],staticClass:"error_msg",attrs:{"id":"error_msg"}},[_vm._v("\n                        "+_vm._s(_vm.error.tokenmessage)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"btn_submit"},[_c('button',{staticClass:"btn btn_sb",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.submit))]),_vm._v(" "),_c('button',{staticClass:"btn btn_cc",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.closePopup.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.cancel))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isApi && !_vm.showDemo)?_c('div',{staticClass:"login"},[_c('div',{staticClass:"title"},[(_vm.customTemplate  && _vm.showLogo)?_c('img',{style:(_vm.customTemplate.logo_login_style_wob),attrs:{"src":_vm.customTemplate.logo_home}}):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"mem",attrs:{"id":"mem"}},[_c('div',{staticClass:"err_info",attrs:{"id":"err_info"}},[_c('font',{attrs:{"id":"hr_info"}},[_vm._v(_vm._s(_vm.lang.sessionExipred))])],1)])]):_c('div',{staticClass:"login"},[_c('popupFestival'),_vm._v(" "),(_vm.popupFlag)?_c('popup',{attrs:{"democreditLogin":_vm.popupFlag,"lang":_vm.lang}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_c('ul',{staticClass:"language"},[_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[2].language_code),on:{"click":function($event){return _vm.changeLanguage(2)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[2].caption)+"版")])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[3].language_code),on:{"click":function($event){return _vm.changeLanguage(3)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[3].caption)+"版")])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[1].language_code),on:{"click":function($event){return _vm.changeLanguage(1)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[1].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[5].language_code),on:{"click":function($event){return _vm.changeLanguage(5)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[5].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[6].language_code),on:{"click":function($event){return _vm.changeLanguage(6)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[6].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[7].language_code),on:{"click":function($event){return _vm.changeLanguage(7)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[7].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[8].language_code),on:{"click":function($event){return _vm.changeLanguage(8)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[8].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[9].language_code),on:{"click":function($event){return _vm.changeLanguage(9)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[9].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[10].language_code),on:{"click":function($event){return _vm.changeLanguage(10)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[10].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[4].language_code),on:{"click":function($event){return _vm.changeLanguage(4)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[4].caption))])])]),_vm._v(" "),_c('span',[_c('li',{class:_vm.langClass(_vm.langSelect[11].language_code),on:{"click":function($event){return _vm.changeLanguage(11)}}},[_c('p',[_vm._v(_vm._s(_vm.langSelect[11].caption))])])])])]),_vm._v(" "),_c('div',{staticClass:"mem",attrs:{"id":"mem"}},[_c('div',{staticClass:"logo-placement",class:_vm.customIcon()},[(_vm.customTemplate)?_c('img',{attrs:{"src":_vm.customTemplate.login_logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"log"},[_c('form',{attrs:{"id":"LoginForm","name":"LoginForm"}},[_c('div',{staticClass:"bordDIV"},[_c('table',{staticClass:"bord",attrs:{"border":"0","cellpadding":"0","cellspacing":"0"}},[_c('tr',[_c('td',{attrs:{"width":"6"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('td',{staticClass:"index_line place_colorTD"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.accname),expression:"formData.accname"}],staticClass:"place_colorBOX",attrs:{"type":"text","id":"username","size":"15","maxlength":_vm.inputLength.username,"tabindex":"1"},domProps:{"value":(_vm.formData.accname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "accname", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lang.username_def),expression:"lang.username_def"}],staticClass:"place_color placeholder",style:(_vm.altDisplay()),attrs:{"type":"text","id":"username_def","size":"10","maxlength":_vm.inputLength.username},domProps:{"value":(_vm.lang.username_def)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lang, "username_def", $event.target.value)}}})]),_vm._v(" "),_c('td',{attrs:{"width":"6"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"width":"6"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('td',{staticClass:"place_colorTD"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.pass),expression:"formData.pass"}],staticClass:"place_colorBOX",attrs:{"type":"password","id":"passwd","size":"15","maxlength":_vm.inputLength.password,"tabindex":"2"},domProps:{"value":(_vm.formData.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "pass", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lang.password_def),expression:"lang.password_def"}],staticClass:"place_color placeholder",style:({'visibility' : _vm.formData.pass.length <= 0 ? 'visible' : 'hidden'}),attrs:{"type":"text","id":"password_def","size":"10","maxlength":_vm.inputLength.username},domProps:{"value":(_vm.lang.password_def)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.lang, "password_def", $event.target.value)}}})]),_c('td',{attrs:{"width":"6"}},[_vm._v(" ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.loginIdReq),expression:"error.loginIdReq"}],staticClass:"err_info",attrs:{"id":"err_info"}},[_c('font',{attrs:{"id":"hr_info"}},[_vm._v(_vm._s(_vm.error.message))])],1),_vm._v(" "),_c('div',{staticClass:"index_re"},[_c('span',{staticClass:"err_position"},[_c('label',[_c('input',{staticClass:"index_box",attrs:{"type":"checkbox","id":"remember"}}),_c('span'),_vm._v(_vm._s(_vm.lang.rememberMe)+"\n                        ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-block za_button",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.login))]),_vm._v(" "),(_vm.showDemo)?_c('button',{staticClass:"btn btn-block za_button",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.demoLogin.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.demo))]):_vm._e(),_vm._v(" "),(_vm.showCreditDemoFlag)?_c('button',{staticClass:"btn btn-block za_button",attrs:{"type":"submit","tabindex":"3"},on:{"click":function($event){$event.preventDefault();return _vm.demo.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.lang.demo))]):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"index_ID index_line"},[_c('img',{attrs:{"src":"assets/images/index_ID.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"index_ID"},[_c('img',{attrs:{"src":"assets/images/index_pass.jpg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);




var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ })

},[258]);


// WEBPACK FOOTER //
// js/auth/login.d3d2e02c9606d8d60b51.js